(ns frontend.view.modals.entity-esign.sub
  (:require
   [common.email :as email]
   [frontend.utils :as fu]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::signatories
 (fn [db _]
   (-> db
       ::signatories
       (or [{:name nil :email nil}]))))

(rf/reg-sub
 ::file
 (fn [db _]
   (-> db
       ::file
       (or nil))))

(rf/reg-sub
 ::valid-signatory-data?
 (fn [db _]
   (let [signatories (::signatories db)]
     (and (seq signatories)
          (->> signatories
               (every? (fn [signatory]
                         (and (email/valid-email-pattern? (:email signatory))
                              (not (fu/empty-value? (:name signatory)))))))))))

(rf/reg-sub
 ::duplicate-emails?
 (fn [db _]
   (and (not (empty? (::signatories db)))
        (not (->> db
                  ::signatories
                  (map :email)
                  (apply distinct?))))))

(rf/reg-sub
 ::esign-attachment-uploaded?
 (fn [db _]
   (not (nil? (::file db)))))

(rf/reg-sub
 ::sent-successfully?
 (fn [db _]
   (-> db
       ::sent-successfully?)))

